module.exports = __webpack_public_path__ + "static/logo_js-e51b1aec7b5facfc8b77a04be0ec2109.svg";